module.exports = __webpack_public_path__ + "static/img/code.e23f03f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/code.png
// module id = EF7e
// module chunks = 0